import React from 'react';

const TeamNotificationRules = ({ style = 'cards' }) => {
  
  if (style === 'inline') {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
        border: '2px solid #3b82f6',
        borderRadius: '12px',
        padding: '16px',
        margin: '16px 0'
      }}>
        <h4 style={{ 
          color: '#1e40af', 
          margin: '0 0 12px 0', 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px' 
        }}>
          🔔 Team Notification Rules
        </h4>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '16px',
          fontSize: '14px' 
        }}>
          <div>
            <strong style={{ color: '#3b82f6' }}>🏢 Agent/Admin sends documents:</strong>
            <ul style={{ margin: '4px 0 0 0', paddingLeft: '20px', color: '#1e40af' }}>
              <li>All team members get notified</li>
              <li>Everyone's calendar updates</li>
            </ul>
          </div>
          
          <div>
            <strong style={{ color: '#8b5cf6' }}>👤 Team member sends documents:</strong>
            <ul style={{ margin: '4px 0 0 0', paddingLeft: '20px', color: '#7c3aed' }}>
              <li>You + Agent/Admin get notified</li>
              <li>Your + Agent's calendar update</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '20px',
      margin: '20px 0'
    }}>
      {/* Agent/Admin Rule Card */}
      <div style={{
        background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
        border: '3px solid #3b82f6',
        borderRadius: '16px',
        padding: '20px',
        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.15)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-2px)';
        e.target.style.boxShadow = '0 8px 24px rgba(59, 130, 246, 0.25)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0px)';
        e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.15)';
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '10px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            background: '#3b82f6',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            overflow: 'hidden'
          }}>
            <img 
              src="/agent_female.jpg" 
              alt="Agent"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div>
            <h4 style={{ color: '#1e40af', margin: 0, fontSize: '18px', fontWeight: '600' }}>
              Team Admin Sends
            </h4>
            <p style={{ color: '#3730a3', margin: 0, fontSize: '14px' }}>
              Documents to SmartClose
            </p>
          </div>
        </div>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.7)',
          borderRadius: '12px',
          padding: '10px'
        }}>
          <h5 style={{ color: '#1e40af', margin: '0 0 12px 0', fontSize: '16px' }}>
            📢 Cross-Team Notification:
          </h5>
          <ul style={{ 
            listStyle: 'none', 
            padding: 0, 
            margin: 0,
            color: '#1e40af' 
          }}>
            <li style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              marginBottom: '8px' 
            }}>
              <span style={{ color: '#22c55e', fontSize: '16px' }}>✓</span>
              <strong>All team members</strong> receive notifications
            </li>
            <li style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              marginBottom: '8px' 
            }}>
              <span style={{ color: '#22c55e', fontSize: '16px' }}>✓</span>
              <strong>Everyone's calendar</strong> gets updated
            </li>
            <li style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px' 
            }}>
              <span style={{ color: '#f59e0b', fontSize: '16px' }}>📧</span>
              Email notifications sent to all
            </li>
          </ul>
        </div>
      </div>

      {/* Team Member Rule Card */}
      <div style={{
        background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)',
        border: '3px solid #8b5cf6',
        borderRadius: '16px',
        padding: '20px',
        boxShadow: '0 4px 12px rgba(139, 92, 246, 0.15)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-2px)';
        e.target.style.boxShadow = '0 8px 24px rgba(139, 92, 246, 0.25)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0px)';
        e.target.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.15)';
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '10px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            background: '#8b5cf6',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            overflow: 'hidden'
          }}>
            <img 
              src="/assistant.png" 
              alt="Team Member"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
          <div>
            <h4 style={{ color: '#7c3aed', margin: 0, fontSize: '18px', fontWeight: '600' }}>
              Team Member Sends
            </h4>
            <p style={{ color: '#6d28d9', margin: 0, fontSize: '14px' }}>
              Documents to SmartClose
            </p>
          </div>
        </div>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.7)',
          borderRadius: '12px',
          padding: '10px'
        }}>
          <h5 style={{ color: '#7c3aed', margin: '0 0 12px 0', fontSize: '16px' }}>
            🎯 Targeted Notifications:
          </h5>
          <ul style={{ 
            listStyle: 'none', 
            padding: 0, 
            margin: 0,
            color: '#7c3aed' 
          }}>
            <li style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              marginBottom: '8px' 
            }}>
              <span style={{ color: '#22c55e', fontSize: '16px' }}>✓</span>
              <strong>You + Agent/Admin</strong> get notified
            </li>
            <li style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              marginBottom: '8px' 
            }}>
              <span style={{ color: '#22c55e', fontSize: '16px' }}>✓</span>
              <strong>Your + Agent's calendar</strong> update
            </li>
            <li style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px' 
            }}>
              <span style={{ color: '#f59e0b', fontSize: '16px' }}>📧</span>
              Targeted email notifications only
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TeamNotificationRules;